import { useParams, useNavigate } from 'react-router-dom';
import { useTelegramOverlayBack } from '../../hooks/useTelegramOverlayBack';
import { TG_OVERLAY_Z } from '../../services/telegramBackStack';
import { BfHome } from '../../components/bible/bf';
import ContextSearchModal from '../../components/bible/ContextSearchModal';
import { isWebAuthenticated } from '../../utils/webAuth';
import { requestAuthPopup } from '../../utils/authPopup';
import { getStoredTranslationOrDefault } from '../../utils/bibleLocaleSync';
import { useState } from 'react';

/**
 * BfHomeRoute — главная со стихом дня и inline-разбором.
 */
export default function BfHomeRoute() {
  const { translation: translationParam } = useParams();
  const translation = translationParam || getStoredTranslationOrDefault();
  const navigate = useNavigate();
  const [showSearch, setShowSearch] = useState(false);

  useTelegramOverlayBack('homeSearch', showSearch, () => setShowSearch(false), TG_OVERLAY_Z.contextSearch);

  const requireAuth = () => {
    if (isWebAuthenticated()) return true;
    requestAuthPopup(`/${translation}/home`, true);
    return false;
  };

  return (
    <>
      <BfHome
        translation={translation}
        onOpenSearch={() => {
          if (!requireAuth()) return;
          setShowSearch(true);
        }}
      />
      {showSearch && (
        <ContextSearchModal
          translation={translation}
          onClose={() => setShowSearch(false)}
        />
      )}
      {!translation && (
        <button
          type="button"
          style={{ display: 'none' }}
          onClick={() => navigate(`/${getStoredTranslationOrDefault()}`)}
          aria-hidden
        />
      )}
    </>
  );
}
